import styled from "styled-components";

export const StyledMenuItem = styled.li`
	list-style-type: none;
	display: inline-flex;
	justify-content: center;
	transition: all 800ms ease-in-out;

	&:not(:last-of-type) {
		margin-bottom: ${({ theme }) => theme.space.sm};
	}

	&.HamburgerMenu__item--expand:not(:last-of-type) {
		margin-bottom: ${({ theme }) => theme.space.xl};
	}
`;
